<template>
  <div class="loading-container">
    <div class="loader"></div>
  </div>
</template>
